<template lang="html">
  <div class="hardwareDesign">
    <div class="imagesCon">
      <img src="@/assets/image/activity/hiTechFair/1.jpg" alt="">
    </div>

    <div class="footerMod" @click="getSkip">
      <img src="@/assets/image/activity/hiTechFair/frame.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      getSkip() {
        window.location.href = 'https://www.ecosmos.vip/cn/activity/208'
      },
    }
  }
</script>

<style lang="css" scoped>
  .hardwareDesign {
    background: #7BA7FF;
  }

  .imagesCon img {
    width: 100%;
  }

  .footerMod {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    z-index: 10;
    padding: 0 75px;
  }

  .footerMod img {
    width: 100%;
  }
  
  .signUp {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(13, 43, 72, 0.01);
    box-sizing: border-box;
    padding: 0 3rem;
    margin-top: 1rem;
  }
  
  .signUpPrice {
    display: flex;
    height: 2rem;
    align-items: flex-end;
  }
  
  .originalCost {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-right: 1rem;
  }
  
  .originalCost span {
    color: #FFC851;
  }
  
  .currentPrice {
    font-size: 1rem;
    color: #CCCCCC;
  }
  
  .currentPrice span {
    color: #FFFFFF;
  }
  
  .signUpBtn {
    width: 10rem;
    height: 3rem;
    line-height: 3rem;
    border-radius: 3rem;
    background-color: #B68043;
    text-align: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  @media (min-width: 751px) {    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>